export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-vimeo-2a1423b46e23af8648b8b1ef8ed978fb.svg";